<template>
  <div class="content">
    <div class="content_middle">
      <p class="content_middle_title page_color_1C2438">身份证照片</p>
      <ul>
        <li
          class="se_bg"
          id="se_bg_pufa"
        >
          <input
            id="uploaderInputSecond"
            class="input uploaderInputSecond"
            v-if="!isPc"
            type="file"
            accept="image/*"
            capture="camera"
            @change="showPositiveImage"
          />
          <img
            :src="positive"
            v-if="positive"
            style="position: absolute;top: 0;left: 0;width: 216px;height:142px"
          />
        </li>
        <p class="instruction"> {{isPc ? '请在手机端拍照上传' : '请上传身份证人像面'}}</p>
        <li
          class=" mgt_15 fs_bg"
          id="fs_bg_pufa"
        >
          <input
            id="uploaderInputFirst"
            class="input uploaderInputFirst"
            v-if="!isPc"
            type="file"
            accept="image/*"
            capture="camera"
            @change="showNegativeImage"
          />
          <img
            :src="negative"
            v-if="negative"
            style="position: absolute;top: 0;left: 0;width: 216px;height:142px"
          />
        </li>
        <p class="instruction"> {{isPc ? '请在手机端拍照上传' : '请上传身份证国徽面'}}</p>
      </ul>
    </div>
    <div class="btnBox">
      <a
        href="javascript:;"
        v-if="!isPc"
        :class="isDisabled?'btn disable':'btn'"
        @click="submit"
      >下一步</a>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
// import { stringify } from 'querystring';
import { Toast } from 'vant';
import service from '@/request/api'; // 导入api接口
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from './mixin';

export default {
  name: 'IdentifyCardUpload',
  components: {
    ServerBank,
  },
  data() {
    return {
      positive: '',
      idFrontPic: '',
      negative: '',
      idBackPic: '',
      isDisabled: false,
      isPc: false,
    };
  },
  mixins: [checkStatus],
  mounted() {
    this.yiLianIsUpload();
  },
  methods: {
    yiLianIsUpload() {
      const np = navigator.platform;
      if (['YL-YPD'].includes(this.$route.query.productId) && (np.indexOf('Win') === 0 || np.indexOf('Mac') === 0)
      ) {
        this.isPc = true;
      }
    },
    showPositiveImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idFrontPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.positive = item.target.result; // 图片内容的base64编码
        };
      }
    },
    showNegativeImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idBackPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.negative = item.target.result; // 图片内容的base64编码
        };
      }
    },
    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的个人头像');
        return false;
      }
      if (file.size.toFixed(5) >= 5 * 1024 * 1024) {
        Toast('请上传小于5M的图片');
        return false;
      }
      return true;
    },
    jumpThirdFc(orderId) {
      service.CommonForms.jumpThirdServer({ orderId }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          this.$toast.clear();
          this.isDisabled = false;
          console.log(res);
        }
      });
    },
    submit() {
      if(this.isDisabled) return;
      if (!this.positive) {
        Toast('请上传身份证人像面的图片');
        return;
      }
      if (!this.negative) {
        Toast('请上传身份证国徽面');
        return;
      }
      if (this.positive && this.negative) {
        this.$toast.loading({
          message: '加载中...',
          clear: true,
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        });
        this.isDisabled = true;
        const { orderId } = this.$store.state.commonForms;
        const form = new FormData();
        form.append('orderId', orderId || localStorage.getItem('orderId'));
        form.append('idFrontPic', this.idFrontPic);
        form.append('idBackPic', this.idBackPic);
        service.CommonForms.checkIdentityPicService(form).then((res) => {
          if (res.success) {
            this.jumpThirdFc(orderId || localStorage.getItem('orderId'));
          } else {
            this.$toast.clear();
            this.isDisabled = false;
            Toast(res.returnMessage || '上传失败');
          }
        }).catch((err) => {
          this.$toast.clear();
          this.isDisabled = false;
          this.$toast.fail({
            message: '网络异常，请稍后再试！',
            forbidClick: true,
            duration: 2500,
          });
        });
      }
    },
  },
};
</script>
<style scoped>
/* 身份认证 */
body {
  background-color: #f8f8f9;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.content_middle {
  box-sizing: border-box;
  padding-right: 15px;
  padding-left: 15px;
  background: #fff;
}

.content_middle_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}

.content_middle ul {
  text-align: center;
  background: #fff;
}

.content_middle ul li {
  position: relative;
  box-sizing: border-box;
  width: 216px;
  height: 142px;
  margin: 0 auto;
  overflow: hidden;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  padding: 0 15px;
}

.btn {
  display: block;
  width: 100%;
  height: 44px;
  padding: 0;
  color: #fff;
  font-size: 17px;
  line-height: 44px;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 4px;
}
.disable{
  cursor: not-allowed;
  opacity: .5;
  color: #fff;
  background-image: linear-gradient(-180deg, #7691a3, #7691a3);
  background-color: #7691a3 !important;
  border: 1px solid #7691a3 !important;
}
/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
}

.page_color_A5ADB9 {
  color: #a5adb9;
}

.page_color_1C2438 {
  color: #1c2438;
}

.fs_bg {
  background: url("~@/assets/images/back.png") center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}

.se_bg {
  margin-top: 0.08rem;
  background: url("~@/assets/images/positive.png") center center;
  background-size: cover;
  border-radius: 0.08rem;
}

/* 文字大小 */
.page_fs_14 {
  font-size: 0.14rem;
}

.mgt_15 {
  margin-top: 0.15rem;
}

.mgb_15 {
  margin-bottom: 0.15rem;
}

.mgt_8 {
  margin-top: 0.08rem;
}

/* input */
.input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.instruction {
  color: #838d9b;
  font-size: 13px;
}
</style>
